import { t } from "i18next";
import PropTypes from "prop-types";
import React from "react";
import { createUseStyles } from "react-jss";
import { useHistory, withRouter } from "react-router-dom";
import { Divider } from "rsuite";
import { Button } from "../components/common/Button";
import jssVariables from "../jss_setup";

const styles = createUseStyles({
  main: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100vw",
    height: "100vh",
    background: jssVariables.colors.background.light,
    zIndex: 9999,
  },
  four: {
    position: "absolute",
    left: "50%",
    top: "50%",
    width: "90vw",
    height: "50vh",
    transform: "translate(-50%, -50%)",
    display: "grid",
    gridAutoRows: "max-content",
    gridGap: `calc(${jssVariables.normal_gap} * 4)`,
  },
  header: {
    textAlign: "center",
    color: jssVariables.colors.base_color,
    fontSize: "64px",
  },
  divider: {
    margin: `0 ${jssVariables.normal_gap}`,
  },
  description: {
    textAlign: "center",
  },
  btnContr: {
    display: "grid",
    justifyContent: "center",
  },
  [`@media ${jssVariables.media.smallscreen}`]: {
    four: {
      width: "50vw",
      height: "50vh",
    },
  },
});

const FourOFour = () => {
  const classes = styles();
  const history = useHistory();

  return (
    <div className={classes.main}>
      <div className={classes.four}>
        <h1 className={classes.header}>404</h1>
        <Divider className={classes.divider} />
        <h4 className={classes.description}>{t("errorMessage404")}.</h4>
        <div className={classes.btnContr}>
          <Button text={t("backToHome")} onClick={() => history.push("/")} />
        </div>
      </div>
    </div>
  );
};

FourOFour.propTypes = {
  history: PropTypes.object.isRequired,
};

export default withRouter(FourOFour);
